export const config = {
    serviceId : 'service_eb3cbgl',
    templateId: 'template_axij83j',
    publicKey: 'AUDU0kMf820Qcjzb6'
}